import styled from 'styled-components';

export const SelectCell = styled.div`
  margin: -10px;
  padding-top: 20px;
  display: flex;
  justify-content: center;
  min-height: 80px;
`;
